<template>
  <div class="content">
    <el-upload
        class="upload-demo"
        ref="upload"
        action="#"
        :before-upload="beforeUpload"
        :show-file-list="false">
      <el-button type="primary" size="mini">导入excel</el-button>
    </el-upload>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import request from "@/utils/request";
import {mapState} from "vuex";

export default {
  name: 'UploadExcel',
  computed: {
    ...mapState({
      user: state => state.user
    }),
  },
  methods: {
    beforeUpload(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

        // 将解析后的数据存储到data或其他地方
        // console.log(jsonData);

        // 调用导入数据的函数
        this.importData(jsonData);
      };
      reader.readAsBinaryString(file);

      // 阻止文件上传
      return false;
    },
    format(dateString) {
      // console.log(dateString)
      const [year, month, day] = dateString.split('.').map(part => parseInt(part, 10));
      const date = new Date(year, month - 1, day);
      // 格式化为 YYYY-MM-DD HH:MM:SS
      const formattedDate = date.getFullYear() + '-' +
          ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
          ('0' + date.getDate()).slice(-2) + ' ' +
          '00:00:00';
      return formattedDate;
    },
    importData(data) {
      // 在这里处理解析后的数据，例如将其发送到服务器或存储到状态管理中
      // 假设data是二维数组，其中第一行是表头，之后是数据行
      const headers = data[0];
      const rows = data.slice(1);

      const importedData = rows.map(row => {
        const item = {};
        headers.forEach((header, index) => {
          item[header] = row[index];
        });
        return item;
      });

      // console.log(importedData);
      const mappedData = importedData.map(item => ({
        title: item["标题"],
        author: item["获奖人"],
        company: item["供稿单位"],
        date: this.format(item["上榜时间"]),
        type: item["榜单分类"],
        recorder: this.user.userName
      }));

      // 你可以在这里调用API将数据发送到服务器
      mappedData.forEach(item => {
        request.post('/masterpieces/add', item).then(response => {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
        }).catch(error => {
          console.error('添加失败:', error);
          this.$message({
            message: '添加失败',
            type: 'error'
          });
        });
        this.$emit('getList');
      });
    }
  }
};
</script>

<style>

</style>
